exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-100p[data-v-3edc523d]{height:100%}.header-table-divider[data-v-3edc523d]{margin-top:2%}.btn-new-identity[data-v-3edc523d]{background-color:#0032a0!important;color:#fff}.v-btn[data-v-3edc523d]{text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3edc523d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/authandvideocall/LeadPartyList.vue
// module id = 1028
// module chunks = 0